import { render, staticRenderFns } from "./Incoming.vue?vue&type=template&id=ef48dde2&scoped=true"
import script from "./Incoming.vue?vue&type=script&lang=js"
export * from "./Incoming.vue?vue&type=script&lang=js"
import style0 from "./Incoming.vue?vue&type=style&index=0&id=ef48dde2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef48dde2",
  null
  
)

export default component.exports